import React, { useState } from "react";
import "src/styles/DropDownMenu.css";
import { Button, Menu, MenuItem, Link } from "@material-ui/core"; 
import { ArrowDropDown } from "@material-ui/icons";

interface MenuItemInfo {
    title: string,  // title to be displayed for the link
    path?: string, // the link href
    cName?: string // the class name of tag
}

type DropDownToggleProps = {
    buttonText: string,
    menuItems: Array<MenuItemInfo>
}

/**
 * This is a re-usable Component. Provides a button with static text and triangle anchor. When the button is clicked, a list of mean display or not 
 */
const DropDownMenu: React.FunctionComponent<DropDownToggleProps> = ({ buttonText, menuItems }) => {
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

    const handleClose = () => {
        setAnchorEl(null);
    }

    const handleClick = (event: React.MouseEvent<any>) => {
        setAnchorEl(event.currentTarget);    
    }

    let listOfMenu = (
        <Menu 
            anchorEl={anchorEl}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right'
            }}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={handleClose}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right'
            }}
            getContentAnchorEl={null}>

            {menuItems.map((menuItem) => (
                <MenuItem 
                    key={menuItem.title}
                    className={menuItem.cName} 
                    component={Link} 
                    href={menuItem.path}>
                    {menuItem.title}
                </MenuItem>
            ))}   
        </Menu>
    );

    return (
        <>
            <Button 
                className="dropdown-toggle"
                size="small"
                onClick={handleClick}
                endIcon={<ArrowDropDown />}>
                {buttonText}
            </Button>
            {listOfMenu} 
        </>    
    );
}

export default DropDownMenu;